module.exports = __webpack_public_path__ + "static/img/2.8c916c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/2.png
// module id = Duez
// module chunks = 1